import React from 'react';

import { GraphProps } from '../../Graph/Types';
import { ComponentData } from '../../Types';

import Draw from './Draw';

import { ObjectShape } from '~/store/reducers/configs';

type InstrumentProps = {
  data: ComponentData;
  objects: ObjectShape[];
  splitValue: number;
  parentid: any;
} & Pick<GraphProps, 'graph'>;

const Instrument = ({ splitValue, parentid, graph, data, objects }: InstrumentProps) => {
  const drawProps = {
    graph,
    data,
    objects,
    splitValue,
    parentid,
  };

  return (
    <React.Fragment>
      <Draw {...drawProps} />
    </React.Fragment>
  );
};

export default Instrument;
